import React from "react";
import {
  MessageSquare,
  Info,
  Send,
  User,
  Bot,
  AlertTriangle,
  ChevronDown,
  ChevronUp,
  Menu,
  X,
  FileText,
  Download,
  Archive,
  LogOut,
  Plus,
  MoreVertical,
  Pencil,
  Trash2,
} from "lucide-react";

export const Icons = {
  MessageSquare,
  Info,
  Send,
  User,
  Bot,
  AlertTriangle,
  ChevronDown,
  ChevronUp,
  Menu,
  X,
  FileText,
  Download,
  Archive,
  LogOut,
  Plus,
  MoreVertical,
  Pencil,
  Trash2,
};

export default Icons;
